// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"H1-z","displaySixCardTiles":"I1-z"};